import React from 'react';
import withAuth from "../../../../../services/withAuth";
import LoadingSpinner from "../../../../../components/LoadingSpinner/index";
import moment from "moment/moment";
import MembersApi from "../../../../../services/portal-api/MembersApi";
import swal from "sweetalert";

export default class InnerTable extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            ItemRows:[],
            filterColumn : this.props.tranColumn,
            filterToken : this.props.tranId,
            givex: this.props.givex
        }
    }

    componentDidMount(){
        MembersApi.getPurchaseHistoryItems((result)=>{
            let rows = [];
            if (result.success) {
                result.json.forEach((v,k) => {
                    rows.push(<tr key={k}><td>{v.Ref_No}</td><td>{v.Item}</td><td style={{textAlign:'right'}}>{v.QTY}</td><td style={{textAlign:'right'}}>{this.props.cur} {v.Sales_Price}</td></tr>);
                });
                this.setState({
                    ItemRows: rows,
                });  
            } else {
                if(result.status === 401){
                    this.props.sessionLogger(result);
                } else {
                    // alert("Fetch inner tables failed.");
                    swal("Fetch inner tables failed", {
                        icon: "warning",
                        buttons: false,
                        timer: 3000
                    });
                }
            }
        },this.state.givex,'',this.state.filterColumn,this.state.filterToken)
    }
    
    render(){
        return(<table><thead><tr>
            <th>Item Code</th>
            <th>Item Name</th>
            <th style={{textAlign:'right'}}>Qty</th>
            <th style={{textAlign:'right'}}>Amount</th>
            </tr>
    </thead>
    <tbody>
    {this.state.ItemRows} 
    {this.state.ItemRows.length === 0 &&
        <tr>
            <td colSpan="4">No results founds.</td>
        </tr>
    } 
    </tbody>
</table>);
    }
}